<template>
  <div>
    <div class="page-title">
      <h3>{{'planing' | langFilter}}</h3>
      <h4>{{info.bill | currencyFilter}}</h4>
    </div>

    <Loader v-if="loading"/>
    <p class="center" v-else-if="!categories.length">{{'noCategory' | langFilter}} <router-link to="/categories">{{'addNewCategory' | langFilter}}</router-link></p>
    <section v-else>
      <div v-for="cat in categories" :key="cat.id" >
        <p>
          <strong>{{cat.name}}:</strong>
          {{cat.spend | currencyFilter}} {{'from' | langFilter()}} {{cat.limit | currencyFilter}}
        </p>
        <div class="progress" v-tooltip="cat.tooltip" style="cursor: pointer" :key="$store.getters.info.lang">
          <div class="determinate"
          :class="[cat.progressColor]"
          :style="{width: cat.progressPercent + '%'}"
          ></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import currencyFilter from '@/filters/currency.filter'
import langFilter from "../filters/lang.filter";
export default {
  metaInfo(){
    return {
      title: this.$title('planing')
    }
  },
  data: () => ({
    categories: [],
    loading: true,
  }),
  computed: {
    ...mapGetters(['info'])
  },
  async mounted() {
    const categories = await this.$store.dispatch('getCategories');
    const records = await this.$store.dispatch('getRecords');

    this.categories = categories.map(cat => {
      const spend = records
        .filter(r => r.categoryId === cat.id)
        .filter(r => r.type === 'outcome')
        .reduce((sum, rec) => {
          return sum += +rec.amount
        }, 0)

      const percent = spend / cat.limit * 100
      const progressPercent = percent > 100 ? 100 : percent;
      const progressColor = percent < 60
        ? "green"
        : percent < 100
          ? "yellow"
          : "red"
      const tooltip = `${currencyFilter(Math.abs(cat.limit - spend))} ${cat.limit - spend > 0 ? langFilter('stayed') : langFilter('limited')}`;

      return {...cat, progressPercent, progressColor, spend, tooltip}
    })
    this.loading = false
  },
}
</script>

<style>
  .progress{
    height: 8px;
  }
</style>
